import React from 'react';
import { Button } from 'antd';
import type { ReactNode } from 'react';

export interface FilterBarProps {
  children: ReactNode;
  onReset?: () => void;
  resetLabel?: string;
}

/** Standard filter row — wraps fields in the shell filter slot with aligned spacing. */
const FilterBar: React.FC<FilterBarProps> = ({
  children,
  onReset,
  resetLabel = 'Reset filters',
}) => {
  return (
    <div className="cp-filter-bar">
      <div className="cp-filter-bar__fields">
        {children}
      </div>
      <Button
        type="default"
        onClick={onReset}
        style={onReset ? undefined : { visibility: 'hidden', pointerEvents: 'none' }}
      >
        {resetLabel}
      </Button>
    </div>
  );
};

export default FilterBar;
